import angular from 'angular'
import commonTemplate from 'views/common/template.html'

const creditLineInfoPage = require('./views/creditLineList.html')
const creditLineCtrl = require('./creditLineCtrl')


export default angular
    .module('app.creditLine', [])
    .config([
        '$stateProvider',
        function config ($stateProvider) {
            $stateProvider
                .state('creditLine', {
                    abstract: true,
                    url: '/creditLine',
                    template: commonTemplate,
                    title: '授信额度',
                    default: 'creditLine.list',
                })
                .state('creditLine.list', {
                    url: '/list',
                    template: creditLineInfoPage,
                    controller: 'creditLineCtrl',
                    title: '授信额度',
                })
        },
    ])
    .controller('creditLineCtrl', creditLineCtrl.default).name



// WEBPACK FOOTER //
// ./src/app/main/creditLine/index.js